import { AlertCircle, CheckCircle, Info, XCircle } from "lucide-react";
import { cn } from "../../utils/cn";

export type AlertSeverity = "error" | "warning" | "info" | "success";

export type ProductAlert = {
  id: string;
  severity: AlertSeverity;
  message: string;
  details?: string;
};

type ProductAlertsProps = {
  alerts: ProductAlert[];
  is_sellable?: boolean;
  className?: string;
};

const severityConfig = {
  error: {
    icon: XCircle,
    bgColor: "bg-danger/10 border-danger/30",
    textColor: "text-danger",
    iconColor: "text-danger",
  },
  warning: {
    icon: AlertCircle,
    bgColor: "bg-warning/10 border-warning/30",
    textColor: "text-warning",
    iconColor: "text-warning",
  },
  info: {
    icon: Info,
    bgColor: "bg-primary/10 border-primary/30",
    textColor: "text-primary",
    iconColor: "text-primary",
  },
  success: {
    icon: CheckCircle,
    bgColor: "bg-success/10 border-success/30",
    textColor: "text-success",
    iconColor: "text-success",
  },
};

export function ProductAlerts({ alerts, is_sellable = true, className }: ProductAlertsProps) {
  return (
    <div className={cn("space-y-2", className)}>
      {!is_sellable && (
        <div className="flex items-center gap-2 rounded-md border border-warning/40 bg-warning/10 px-3 py-2 text-sm text-warning">
          <span className="size-2.5 rounded-full bg-warning" aria-hidden />
          <span className="font-medium">Configuration incomplète</span>
        </div>
      )}
      {alerts.length > 0 && alerts.map((alert) => {
        const config = severityConfig[alert.severity];
        const Icon = config.icon;

        return (
          <div
            key={alert.id}
            className={cn(
              "flex items-start gap-3 rounded-md border px-3 py-2 text-sm",
              config.bgColor,
              config.textColor
            )}
          >
            <Icon size={16} className={cn("mt-0.5 flex-shrink-0", config.iconColor)} />
            <div className="flex-1 min-w-0">
              <p className="font-medium">{alert.message}</p>
              {alert.details && (
                <p className="mt-1 text-xs opacity-80">{alert.details}</p>
              )}
            </div>
          </div>
        );
      })}
    </div>
  );
}
